<template>
  <transition name="modal-fade">
    <v-dialog :value="active" width="160vh" persistent>
      <v-card class="logWrap">
        <my-table
          :fields="this.fields"
          :modalCode="modalCode"
          :title="titulo"
          :url="this.getUrl()"
          element="Usuario"
          itemKey="id"
        >
        </my-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirm('cerrar')"
            class="white--text logWrap"
            color="#004283"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      titulo: "Gestión de Usuarios",
      url: "",
      modalCode: 1,
      fields: [
        {
          text: "Nombre de Usuario",
          sortable: true,
          value: "username",
          align: "center"
        },
        {
          text: "Nombre",
          sortable: true,
          value: "nombre",
          align: "center"
        },
        {
          text: "Email",
          sortable: true,
          value: "email",
          align: "center"
        },
        {
          text: "Rol de usuario",
          sortable: true,
          value: "role.name",
          align: "center"
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          align: "center"
        }
      ]
    };
  },
  methods: {
    confirm(action) {
      this.$emit("closeUS", action);
    },
    getUrl() {
      return this.$baseBackUrl + "api/usuarios";
    }
  },
  mounted() {}
};
</script>

<style scoped>
.logWrap {
  border-radius: 2em;
  padding: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalUsers.vue